<template>
  <div id="#app">
    <header class="header-global">
      <base-nav class="navbar-main" transparent type effect="light" expand>
        <a slot="brand" class="navbar-brand mr-lg-5" href="#">
          <img src="img/brand/icon-new.png" />
        </a>

        <div class="row" slot="content-header" slot-scope="{closeMenu}">
          <div class="col-6 collapse-brand">
            <a href="#">
              <img src="img/brand/icon-new-2.png" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <close-button @click="closeMenu"></close-button>
          </div>
        </div>

        <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
          <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
            <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
              <i class="ni ni-ui-04 d-lg-none"></i>
              <span class="nav-link-inner--text">{{ message[currentLocale].navMenu }}</span>
            </a>
            <div class="dropdown-menu-inner">
              <a
                href="#title-id"
                v-smooth-scroll="{ duration: 1000, offset: -50 }"
                class="media d-flex align-items-center"
              >
                <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                  <i class="ni ni-app"></i>
                </div>
                <div class="media-body ml-3">
                  <h6 class="heading text-primary mb-md-1">{{ message[currentLocale].navSub1 }}</h6>
                  <p
                    class="description d-none d-md-inline-block mb-0"
                  >{{ message[currentLocale].navDeatil1 }}</p>
                </div>
              </a>
              <a
                href="#contact-id"
                v-smooth-scroll="{ duration: 1000, offset: -50 }"
                class="media d-flex align-items-center"
              >
                <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                  <i class="ni ni-ruler-pencil"></i>
                </div>
                <div class="media-body ml-3">
                  <h5 class="heading text-warning mb-md-1">{{ message[currentLocale].navSub2 }}</h5>
                  <p
                    class="description d-none d-md-inline-block mb-0"
                  >{{ message[currentLocale].navDeatil2 }}</p>
                </div>
              </a>
            </div>
          </base-dropdown>

          <li class="nav-item mappico-lang-menu">
            <select v-model="currentLocale" class="mappico-select" style="color: #fff;">
              <option
                v-for="locale in locales"
                v-bind:value="locale.id"
              >{{locale.flag}}{{locale.name}}</option>
            </select>
          </li>
        </ul>
        <ul class="navbar-nav align-items-lg-center ml-lg-auto">
          <li class="nav-item">
            <a
              class="nav-link nav-link-icon"
              href="https://www.facebook.com/MappicoGISLAB/"
              data-toggle="tooltip"
              title="Like us on Facebook"
            >
              <i class="fa fa-facebook-square"></i>
              <span class="nav-link-inner--text d-lg-none">Facebook</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link nav-link-icon"
              href="https://www.linkedin.com/company/mappico"
              data-toggle="tooltip"
              title="Connect with us on Linkedin"
            >
              <i class="fa fa-linkedin-square"></i>
              <span class="nav-link-inner--text d-lg-none">Linkedin</span>
            </a>
          </li>
          <li class="nav-item mappico-login-menu">
            <base-button
              block
              size="sm"
              outline
              type="danger"
              icon="ni ni-button-power"
              tag="a"
              href="https://service.mappico.co.th"
            >{{ message[currentLocale].login }}</base-button>
          </li>
          <li class="nav-item d-none d-lg-block ml-lg-4">
            <a href="https://service.mappico.co.th" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon">
                <i class="ni ni-button-power mr-2" style="color: #f5365c"></i>
              </span>
              <span
                class="nav-link-inner--text"
                style="color: #f5365c"
              >{{ message[currentLocale].login }}</span>
            </a>
          </li>
          <li class="nav-item mappico-login-menu" style="margin-top: 20px;">
            <select v-model="currentLocale" class="mappico-select">
              <option
                v-for="locale in locales"
                v-bind:value="locale.id"
              >{{locale.flag}}{{locale.name}}</option>
            </select>
          </li>
        </ul>
      </base-nav>
    </header>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <vue-particles
          class="shape shape-skew mappico-image-background"
          style="z-index: 1 !important;"
          :particlesNumber="20"
          shapeType="circle"
          :moveSpeed="3"
          :hoverEffect="true"
          hoverMode="grab"
          :clickEffect="true"
          clickMode="push"
        ></vue-particles>
        <!-- <div class="shape shape-style-1 shape-default shape-skew mappico-image-background">
        
        </div>-->
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-6 text-center" style="z-index: 2 !important;">
                <h1 class="display-3 text-white">{{ message[currentLocale].title }}</h1>
                <br />
                <br />
                <p class="lead text-white">{{ message[currentLocale].titleSub }}</p>
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    href="#content-id"
                    class="mb-3 mb-sm-0"
                    type="danger"
                    icon="ni ni-bold-down"
                    v-smooth-scroll="{ duration: 1000, offset: -50 }"
                  >{{ message[currentLocale].titleBtn }}</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid" id="content-id">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-square-pin"
                    type="primary"
                    rounded
                    class="mb-4"
                    style="color: #8A2387; background-color: rgba(138, 35, 135, 0.5);"
                  ></icon>
                  <h6
                    class="text-primary text-uppercase"
                    style="color: #8A2387 !important;"
                  >{{ message[currentLocale].heading1 }}</h6>
                  <p class="description mt-3">{{ message[currentLocale].detail1 }}</p>
                  <!-- <div>
                          <badge type="primary" rounded>design</badge>
                          <badge type="primary" rounded>system</badge>
                          <badge type="primary" rounded>creative</badge>
                  </div>-->
                  <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                          Learn more
                  </base-button>-->
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-delivery-fast"
                    type="success"
                    rounded
                    class="mb-4"
                    style="color: #E94057; background-color: rgba(233, 64, 87, 0.5);"
                  ></icon>
                  <h6
                    class="text-success text-uppercase"
                    style="color: #E94057 !important;"
                  >{{ message[currentLocale].heading2 }}</h6>
                  <p class="description mt-3">{{ message[currentLocale].detail2 }}</p>
                  <!-- <div>
                          <badge type="success" rounded>business</badge>
                          <badge type="success" rounded>vision</badge>
                          <badge type="success" rounded>success</badge>
                  </div>-->
                  <!-- <base-button tag="a" href="#" type="success" class="mt-4">
                          Learn more
                  </base-button>-->
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-map-big"
                    type="warning"
                    rounded
                    class="mb-4"
                    style="color: #F27121; background-color: rgb(242, 113, 33, 0.5);"
                  ></icon>
                  <h6
                    class="text-warning text-uppercase"
                    style="color: #F27121 !important;"
                  >{{ message[currentLocale].heading3 }}</h6>
                  <p class="description mt-3">{{ message[currentLocale].detail3 }}</p>
                  <!-- <div>
                          <badge type="warning" rounded>marketing</badge>
                          <badge type="warning" rounded>product</badge>
                          <badge type="warning" rounded>launch</badge>
                  </div>-->
                  <!-- <base-button tag="a" href="#" type="warning" class="mt-4">
                          Learn more
                  </base-button>-->
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="img/theme/promo-3.png" class="img-fluid floating" />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5"
                size="lg"
                shadow
                rounded
                style="color: #F27121; background-color: rgb(242, 113, 33, 0.5);"
              ></icon>
              <h3>{{ message[currentLocale].title2 }}</h3>
              <p>{{ message[currentLocale].title2Sub }}</p>
            </div>
            <div class="pr-md-5">
              <tabs class="flex-column flex-md-row">
                <card shadow slot-scope="{activeTabIndex}">
                  <tab-pane key="tab1">
                    <span slot="title" class="nav-link-icon d-block">
                      <i class="fa fa-bus"></i>
                    </span>
                    <h5 style="color: #F27121;">{{ message[currentLocale].feature1Title }}</h5>
                    <p class="description">{{ message[currentLocale].feature1Detail }}</p>
                  </tab-pane>

                  <tab-pane key="tab2">
                    <span slot="title" class="nav-link-icon d-block">
                      <i class="fa fa-codepen"></i>
                    </span>
                    <h5 style="color: #F27121;">{{ message[currentLocale].feature2Title }}</h5>
                    <p class="description">{{ message[currentLocale].feature2Detail }}</p>
                  </tab-pane>

                  <tab-pane key="tab3">
                    <span slot="title" class="nav-link-icon d-block">
                      <i class="fa fa-cube"></i>
                    </span>
                    <h5 style="color: #F27121;">{{ message[currentLocale].feature3Title }}</h5>
                    <p class="description">{{ message[currentLocale].feature3Detail }}</p>
                  </tab-pane>

                  <tab-pane key="tab4">
                    <span slot="title" class="nav-link-icon d-block">
                      <i class="fa fa-database"></i>
                    </span>
                    <h5 style="color: #F27121;">{{ message[currentLocale].feature4Title }}</h5>
                    <p class="description">{{ message[currentLocale].feature4Detail }}</p>
                  </tab-pane>
                </card>
              </tabs>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg-secondary" id="title-id">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/theme/taxispeed-2-1024x747.png'" class="card-img-top" />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon points="0,52 583,95 0,95" class="fill-default" />
                  <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default" />
                </svg>
                <h4
                  class="display-3 font-weight-bold text-white"
                >{{ message[currentLocale].title3sidehead }}</h4>
                <p class="lead text-italic text-white">{{ message[currentLocale].title3sidedetail }}</p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon name="ni ni-settings" class="mb-5" size="lg" type="danger" shadow rounded></icon>

              <h3>Mappico</h3>
              <p class="lead">{{ message[currentLocale].title3 }}</p>
              <p>{{ message[currentLocale].title3Sub }}</p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-car"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].title3feature1 }}</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-object-group"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].title3feature2 }}</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-bell-o"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].title3feature3 }}</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-feed"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].title3feature4 }}</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-lg section-shaped overflow-hidden my-0">
      <div class="shape shape-style-1 shape-default shape-skew mappico-image-background-2">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0 pb-lg">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-5 mb-lg-0">
            <h1 class="text-white font-weight-light">{{ message[currentLocale].title4 }}</h1>
            <p class="lead text-white mt-4">{{ message[currentLocale].title4Sub }}</p>
          </div>
          <div class="col-lg-6 mb-lg-auto">
            <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
              <b-carousel id="carousel1" controls indicators>
                <!-- Text slides with image -->
                <b-carousel-slide img-src="img/theme/screen-1.png"></b-carousel-slide>
                <b-carousel-slide img-src="img/theme/screen-2.png"></b-carousel-slide>
              </b-carousel>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="title-id">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon name="ni ni-settings" class="mb-5" size="lg" type="danger" shadow rounded></icon>
              <h3>{{message[currentLocale].productName}}</h3>
              <p class="lead">{{ message[currentLocale].product }}</p>
              <p>
                <b>{{message[currentLocale].productSub1.split(":")[0] }}</b>
                {{message[currentLocale].productSub1.split(":")[1] }}
              </p>
              <p>
                <b>{{message[currentLocale].productSub2.split(":")[0] }}</b>
                {{message[currentLocale].productSub2.split(":")[1] }}
              </p>
              <p>
                <b>{{message[currentLocale].productSub3.split(":")[0] }}</b>
                {{message[currentLocale].productSub3.split(":")[1] }}
              </p>
              <p>
                <b>{{message[currentLocale].productSub4.split(":")[0] }}</b>
                {{message[currentLocale].productSub4.split(":")[1] }}
              </p>
              <p>
                <b>{{message[currentLocale].productSub5.split(":")[0] }}</b>
                {{message[currentLocale].productSub5.split(":")[1] }}
              </p>
              <p>
                <b>{{message[currentLocale].productSub6.split(":")[0] }}</b>
                {{message[currentLocale].productSub6.split(":")[1] }}
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-car"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].productfeature1 }}</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-bell-o"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].productfeature2 }}</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="danger" circle class="mr-3" icon="fa fa-feed"></badge>
                    <h6 class="mb-0">{{ message[currentLocale].productfeature3 }}</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card bg-danger shadow border-0">
              <img v-lazy="'img/theme/obd-tracker.png'" class="card-img-top" />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon points="0,52 583,95 0,95" class="fill-danger" />
                  <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-danger" />
                </svg>
                <h4
                  class="display-3 font-weight-bold text-white"
                >{{ message[currentLocale].productsidehead }}</h4>
                <p
                  class="lead text-italic text-white"
                >{{ message[currentLocale].productsidedetail }}</p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-lg" id="contact-id">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              {{ message[currentLocale].contact }}
              <span
                class="text-success"
                style="color: #F27121 !important;"
              >{{ message[currentLocale].contact2 }}</span>
            </h2>
            <p class="lead">
              {{ message[currentLocale].address1 }}
              <br />
              {{ message[currentLocale].address2 }}
              <br />
              {{ message[currentLocale].address3 }}
              <br />
              {{ message[currentLocale].address4 }}
            </p>
            <div class="text-center text-muted mb-4">
              <small>{{ message[currentLocale].breakTitle }}</small>
            </div>
            <div class="btn-wrapper">
              <a
                href="javascript:void(0)"
                class="btn btn-danger mb-3 mb-sm-0"
                @click="modals.modal1 = true"
              >{{ message[currentLocale].contactbtn }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <modal
      :show.sync="modals.modal1"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0"
      >
        <template>
          <form role="form">
            <h4 class="mb-1">{{ message[currentLocale].formTitle }}</h4>
            <p class="mt-0">{{ message[currentLocale].formSub }}</p>
            <base-input
              v-model="name"
              class="mt-5"
              alternative
              placeholder="Your name"
              addon-left-icon="ni ni-single-02"
            ></base-input>
            <base-input alternative placeholder="Email address" addon-left-icon="ni ni-email-83"></base-input>
            <base-input class="mb-4">
              <textarea
                class="form-control form-control-alternative"
                name="name"
                rows="4"
                cols="80"
                placeholder="Type a message..."
              ></textarea>
            </base-input>
            <base-button type="default" round block size="lg">{{ message[currentLocale].formbtn }}</base-button>
          </form>
        </template>
      </card>
    </modal>
  </div>
</template>
      </card>
    </modal>
  </div>
</template>
    </card>
  </modal>
</div>
</template>

<script>
import BCarousel from "bootstrap-vue/esm/components/carousel/carousel";
import BCarouselSlide from "bootstrap-vue/esm/components/carousel/carousel-slide";
import Modal from "@/components/Modal.vue";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  name: "home",
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    BCarousel,
    BCarouselSlide,
    Modal,
    Tabs,
    TabPane
  },
  data() {
    return {
      name: "",
      message: {
        en: {
          navMenu: "Services",
          navSub1: "Details",
          navDeatil1: "Find out more what we are capable of.",
          navSub2: "Contact",
          navDeatil2: "Further information, please contact us here.",
          login: "Log in",
          title: "The wisdom in mobility",
          titleSub:
            "Finest real-time tracking application with customized geofencings.",
          titleBtn: "Explore NOW!",
          heading1: "GPS Tracking",
          detail1:
            "Finest real-time tracking application with customized geofencings to support your personal preferences.",
          heading2: "MANAGEMENT",
          detail2:
            "We support the users to manage along with their personalize vehicles and drivers management system.",
          heading3: "MAP-BASED APPLICATION",
          detail3:
            "We provide tailor-made and cutting edge applications on maps to satisfy your needs.",
          title2: "A few things we’re great at",
          title2Sub:
            "At Mappico, we focus on spatial applications and analytics. We are experienced professional team of engineers and data scientists that capable to handle massive dataset, as massive as 6 BILLION spatial data points.",
          feature1Title: "BIG DATA ANALYSIS",
          feature1Detail:
            "Human and vehicles flow analysis with dedicated tools such as Apache Hadoop, Hive, and Spark.",
          feature2Title: "CODE AT SCALE",
          feature2Detail:
            "Our codes are made to handle massive datasets with scalable infrastructure!",
          feature3Title: "SPATIAL APPLICATIONS",
          feature3Detail:
            "We tailor made your map-based application. Only your imagination is the limit.",
          feature4Title: "REALTIME APPLICATION",
          feature4Detail:
            "Vehicle tracking applications with cutting-edge web technologies.",
          title3: "Special Advantages",
          title3Sub:
            "Mappico is a provider of GPS tracking products and IT solution services in Thailand. Currently, we are developing the special programs for matching with customizable demands of customers in the term of transportation and mapping system management.",
          title3feature1: "Accuracy of information in Centimetre level (cm.)",
          title3feature2: "Free-form geofencing with customizable conditions",
          title3feature3: "Multi-channel alert e.g. Email, LINE Chat Bot",
          title3feature4: "4G signal support",
          title3sidehead: "GPS Tracking device",
          title3sidedetail:
            "It is real time tracker that is made from the durable material with the intelligent system. Moreover, it can be used for driver monitoring and document reporting.",
          title4: "IT solution provider",
          title4Sub:
            "Mappico provide the solution for solving the problem and finding the best way for your business.",
          contact: "Getting interested?",
          contact2: "Contact us below",
          address1: "41 Kaeo Ngoen Thong Road, Khlong Chak Phra,",
          address2: "Talingchan, Bangkok 10170 ",
          address3: "info@mappico.co.th ",
          address4: "+66951265639",
          breakTitle: "...Or",
          contactbtn: "Press Here!!",
          formTitle: "More details?",
          formSub: "please contact us using below form.",
          formbtn: "Send Message",
          product: "Technical Specification",
          productName: "MPC-TLO1 OBD Tracker",
          productSub1: "Data Transmussion: Packet data(GPRS/HSPA/LTE) and SMS",
          productSub2:
            "Wifi: WLAN Standard 2.4Ghz , Tranmission data 802.11b/g/n",
          productSub3: "Working voltage: 9-36 VDC",
          productSub4: "OBD Interface: 16pin standard OBD II ",
          productSub5: "SIM Card Interface: Micro SIM",
          productSub6: "Size: 63mm(L) x 50mm(W) x 26mm(H)",
          productfeature1: "Monitoring your engine condition",
          productfeature2: "Free-form geofencing with customizable conditions",
          productfeature3: "4G signal support",
          productsidedetail:
            "GPS tracker and 4G-WIFI Hotspot with OBD plug & play interface that provide realtime tracking and monitoring solution for fleet management,insurers car leasing, etc "
        },
        th: {
          navMenu: "บริการของเรา",
          navSub1: "ข้อมูลเพิ่มเติม",
          navDeatil1: "อยากรู้จักเรามากขึ้น, กดที่นี่",
          navSub2: "ติดต่อเรา",
          navDeatil2: "สนใจสินค้า, ติดต่อเราได้ที่นี่",
          login: "เข้าสู่ระบบ",
          title: "มิติใหม่ของการเดินทางแห่งโลกอนาคต",
          titleSub:
            "แอปพลิเคชันเพื่อการติดตามแบบเรียลไทม์ (Real-time) ด้วยเงื่อนไขการกำหนดขอบเขตระยะห่างระหว่างวัตถุที่คุณสามารถกำหนดได้",
          titleBtn: "ดูเพิ่มเติม",
          heading1: "ระบบติดตามยานพาหนะ",
          detail1:
            "การติดตามยานพาหนะแบบเรียลไทม์ (Real-time) ที่ดีที่สุดด้วยการกำหนดขอบเขตระยะห่างระหว่างวัตถุได้อย่างถูกต้อง",
          heading2: "การจัดการ",
          detail2:
            "เราช่วยคุณในการจัดการทั้งในส่วนของยานพาหนะและผู้ขับขี่อย่างเป็นระบบและปลอดภัยมากยิ่งขึ้น",
          heading3: "แอปพลิเคชันเชิงพื้นที่",
          detail3:
            "ด้วยความเชี่ยวชาญด้านแผนที่ จึงมีบริการกำหนดขอบเขตบนแผนที่เพื่อตอบสนองความต้องการของคุณได้อย่างตรงจุด",
          title2: "ชวนคุณมาสัมผัสสิ่งที่ดีที่สุดได้ที่นี่",
          title2Sub:
            "Mappico มุ่งเน้นการใช้งานเชิงพื้นที่และการวิเคราะห์ เราเป็นทีมวิชาการที่มีความชำนาญด้านข้อมูล ซึ่งมีประสบการณ์เกี่ยวกับการจัดการกับชุดข้อมูลขนาดใหญ่ได้มากถึง 6 พันล้านดอลลาร์สหรัฐ",
          feature1Title: "การวิเคราะห์เซ็ตข้อมูลขนาดใหญ่",
          feature1Detail:
            "กระบวนการวิเคราะห์เซ็ตข้อมูลขนาดใหญ่เพื่อค้นหารูปแบบความสัมพันธ์ของข้อมูลเหล่านั้น ผลการวิเคราะห์ข้อมูลนี้สามารถนำไปสู่การวิเคราะห์พฤติกรรมการใช้ยานพาหนะบนท้องถนน เพื่อปรับปรุงการขับขี่ให้เกิดความปลอดภัยและมีประสิทธิภาพมากยิ่งขึ้น ซึ่ง Mappico วิเคราะห์ด้วย Apache Hadoop, Hive และ Spark",
          feature2Title: "การปรับขนาดด้วยโค้ด",
          feature2Detail:
            "โค้ดของเราสร้างมาเพื่อจัดการชุดข้อมูลขนาดใหญ่ที่มีโครงสร้างพื้นฐานที่สามารถปรับขนาดได้อย่างเหมาะสมและเป็นมาตรฐาน",
          feature3Title: "แอปพลิเคชันเชิงพื้นที่",
          feature3Detail:
            "เราสามารถปรับแต่งโปรแกรมประยุกต์บนแผนที่ ให้มีขอบเขตความสามารถตามความต้องการของคุณได้อย่างเฉพาะเจาะจง ทุกอย่างเกิดขึ้นได้ จะไม่จำกัดแค่ในความคิดของคุณอีกต่อไป",
          feature4Title: "แอปพลิเคชันแบบเรียลไทม์",
          feature4Detail:
            "การติดตามยานพาหนะด้วยเทคโนโลยีที่เวลาตามสถานการณ์ปัจจุบัน สามารถรายงานผลได้ทันทีตลอดเวลา",
          title3: "สิ่งพิเศษที่เหนือกว่าใครที่คุณจะได้รับจากเรา...",
          title3Sub:
            "เราเป็นผู้ขายผลิตภัณฑ์ติดตามยานพาหนะและบริการแก้ไขปัญหาทางสารสนเทศเชิงพื้นที่ต่าง ๆ ในประเทศไทย ในปัจจุบัน เรากำลังพัฒนาโปรแกรมให้มีความพิเศษเพื่อให้ตรงกับความต้องการของผู้ใช้บริการอย่างมากที่สุด โดยเฉพาะอย่างยิ่งในเรื่องของระบบการเดินทางและการจัดการระบบแผนที่",
          title3feature1:
            "สามารถแสดงเส้นทางของรถและข้อมูลต่าง ๆ ได้แม่นยำมากกว่าในระดับเซนติเมตร",
          title3feature2:
            "สามารถให้ลูกค้ากำหนดพื้นที่โดยการวาดขอบเขตตามเงื่อนไขต่างๆที่ลูกค้าต้องการ เช่น จำกัดความเร็ว พื้นที่ห้ามเข้า เป็นต้น",
          title3feature3:
            "ทำการแจ้งเตือนเหตุการณ์ต่างๆผ่านหลายช่องทาง ได้แก่ Web application, Email, LINE Chat Bot",
          title3feature4:
            "สามารถใช้งานด้วยการรองรับสัญญาณ 4G และใช้เทคโนโลยีล่าสุด ซึ่งต่างจากคู่แข่งที่ยังมีการใช้งานในระบบ 2G/3G เท่านั้น",
          title3sidehead: "อุปกรณ์ติดตามยานพาหนะ",
          title3sidedetail:
            "อุปกรณ์เป็นตัวติดตามแบบเรียลไทม์ ซึ่งผลิตมาจากวัสดุที่แข็งแรง ทนทาน รวมเข้ากับระบบที่มีความสามารถสูง ยิ่งไปกว่านั้น อุปกรณ์นี้สามารถใช้สำหรับการสอดส่องติดตามพฤติกรรมผู้ขับขี่และการรายงานผลทางสถิติและเอกสารต่าง ๆ",
          title4: "ผู้แก้ไขปัญหาทางสารสนเทศต่าง ๆ",
          title4Sub:
            "เราจัดการกับปัญหาทางสารสนเทศต่าง ๆ ด้วยทางออกที่ดีที่สุดสำหรับธุรกิจของคุณ",
          contact: "สนใจผลิตภัณฑ์?",
          contact2: "ติดต่อเรา",
          address1: "41 ถนนแก้วเงินทอง คลองชักพระ,",
          address2: "ตลิ่งชัน กรุงเทพมหานคร 10170",
          address3: "info@mappico.co.th ",
          address4: "+66951265639",
          breakTitle: "หรือฝากข้อความไว้ให้เราด้านล่างนี้",
          contactbtn: "กดที่นี่!!",
          formTitle: "ต้องการรายละเอียดเพิ่มเติม",
          formSub: "โปรดติดต่อเราด้วยการกรอกข้อมูลของท่านดังนี้",
          formbtn: "ส่งข้อความ",
          product: "ข้อมูลทางเทคนิค",
          productName: "เครื่องติดตาม MPC-TLO1 OBD",
          productSub1: "การส่งข้อมูล: Packet data(GPRS/HSPA/LTE) and SMS",
          productSub2:
            "สัญญาณ WIFI: WLAN Standard 2.4Ghz , Tranmission data 802.11b/g/n",
          productSub3: "แรงดันไฟฟ้า: 9-36 VDC",
          productSub4: "การเชื่อมต่อ OBD: 16pin standard OBD II ",
          productSub5: "ซิมการ์ด: Micro SIM",
          productSub6: "ขนาด: 63 มม.(ยาว) x 50 มม.(กว้าง) x 26 มม.(สูง)",
          productfeature1: "สามารถตรวจสอบสภาพของเครื่องยนต์ของคุณ",
          productfeature2: "สามารถกำหนดขอบเขตบนแผนที่ ได้ตามต้องการตามสถานการณ์",
          productfeature3: "รองรับการเชื่อมต่อแบบ 4G",
          productsidehead: "MPC-TLO1",
          productsidedetail:
            "เครื่องติดตาม GPS ที่มาพร้อมกับ ฮ็อตสปอต 4G-WIFI เชื่อมต่อด้วยพอร์ท OBD ซึ่งให้บริการการติดตาม และแสดงผลแบบเรียลไทม์ เพื่อการจัดกราอย่างรวดเร็ว และผู้ให้บริการรถเช่า"
        }
      },
      currentLocale: "en",
      locales: [
        {
          id: "en",
          flag: "🇬🇧",
          name: "English"
        },
        {
          id: "th",
          flag: "🇹🇭",
          name: "ไทย"
        }
      ],
      modals: {
        modal1: false
      }
    };
  }
};
</script>
